import { CategoryData } from '../../../../types/types';

export const corps: CategoryData = {
    // Tête et visage
    'ⲁⲡⲉ (ape)': {
        translation: 'Tête',
        translationEn: 'Head',
        illustration: '👤'
    },
    'ⲃⲁⲗ (bal)': {
        translation: 'Œil / Yeux',
        translationEn: 'Eye / Eyes',
        illustration: '👁️'
    },
    'ϣⲁ (ša)': {
        translation: 'Nez',
        translationEn: 'Nose',
        illustration: '👃'
    },
    'ⲣⲟ (ro)': {
        translation: 'Bouche',
        translationEn: 'Mouth',
        illustration: '👄',
        audio: 'Co-Ro'
    },
    'ⲙⲁⲁϫⲉ (maaje)': {
        translation: 'Oreille / Oreilles',
        translationEn: 'Ear / Ears',
        illustration: '👂'
    },
    'ϥⲱ (fô)': {
        translation: 'Cheveux',
        translationEn: 'Hair',
        illustration: '💇'
    },

    // Membres
    'ⲟⲩⲉⲣⲏⲧⲉ (ouerête)': {
        translation: 'Jambe / Jambes',
        translationEn: 'Leg / Legs',
        illustration: '🦵'
    },
    'ϭⲓϫ (chij)': {
        translation: 'Bras / Main',
        translationEn: 'Arm / Hand',
        illustration: '💪'
    },
    'ⲧⲏⲃ (têb)': {
        translation: 'Doigt',
        translationEn: 'Finger',
        illustration: '👆'
    },
    'ⲣⲁⲧ (rat)': {
        translation: 'Pied',
        translationEn: 'Foot',
        illustration: '🦶'
    },

    // Tronc et Organes
    'ⲧⲉⲃⲧ (tebt)': {
        translation: 'Ventre / Abdomen',
        translationEn: 'Belly / Abdomen',
        illustration: '🤰' // AUDIO À VÉRIFIER
    },
    'ϩⲏⲧ (hêt)': {
        translation: 'Cœur / Esprit',
        translationEn: 'Heart / Spirit',
        illustration: '❤️'
    },
    'ⲙⲉⲥⲧϩⲏⲧ (mesthet)': {
        translation: 'Estomac / Région du cœur',
        translationEn: 'Stomach / Heart region',
        illustration: '🫃'
    },
    'ϩⲟⲩ (hou)': {
        translation: 'Dos',
        translationEn: 'Back',
        illustration: '🧍' // AUDIO À VÉRIFIER
    },
    'ⲙⲟⲩⲧ (mout)': {
        translation: 'Cou / Gorge',
        translationEn: 'Neck / Throat',
        illustration: '🦒'
    }
};

export default corps;
